/*
 * @Description: 公共 api
 * @Author: PF
 * @Date: 2023-01-29 18:32:53
*/
import request from '@/api/request'
import axios from 'axios'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { ElMessageBox, ElLoading } from 'element-plus'
import requestDownload from '@/utils/requestDownload'

export function actionGet (options) {
  return request({
    url: options.url,
    method: 'GET',
    params: options.query
  })
}

export function actionPost (options) {
  options.method = 'POST'
  return request(options)
}
export function actionPatch (options) {
  options.method = 'PATCH'
  return request(options)
}
export function actionDelete (options) {
  options.method = 'DELETE'
  return request(options)
}

/** -------------------- 数据加载区 ------------------------ */

// 获取分页列表
export function loadList (options) {
  const dataGrid = options.dataGrid
  if (dataGrid.orderBy) {
    dataGrid.parms.order = dataGrid.orderBy.prop || '' // 排序条件
    dataGrid.parms.sort = dataGrid.orderBy.order === 'ascending' ? 'asc' : 'desc' // 排序方式
  }
  dataGrid.parms.pageNo = options.pageNo // 当前页数
  dataGrid.parms.pageSize = options.pageSize // 每页条数
  dataGrid.parms.menuId = sessionStorage.getItem('menuId')
  if (dataGrid.parms.menuid || dataGrid.parms.menuid === null) {
    dataGrid.parms.menuId = undefined
  }
  // 分割线----------------------------------------------------
  const o = { url: options.url, data: dataGrid.parms }
  dataGrid.loading = true // 开始加载
  actionPost(o).then((res) => {
    dataGrid.loading = false // 结束加载
    if (res.code === 200) {
      // dataGrid.pagination = { // 返回分页所需数据
      dataGrid.pagination.pageNo = options.pageNo || 1
      dataGrid.pagination.pageSize = options.pageSize || 100
      dataGrid.pagination.pagerCount = options.pagerCount || 11 // 最大页码按钮数
      dataGrid.pagination.layout = options.layout || '' // 组件布局
      dataGrid.pagination.total = res.data.total
      // }
      dataGrid.data = res.data.list || [] // 返回列表
      if (options.loadSuccess) {
        options.loadSuccess(res) // 加载成功后执行
      }
    } else {
      warningPrompt(res.message)
    }
  })
  //   分割线完---------------------------------------------------
}
// 获取详情
export function loadData (options) {
  const ruleForm = options.ruleForm
  const o = { url: options.url }
  if (options.parms) {
    o.data = options.parms
    o.data.menuId = sessionStorage.getItem('menuId')
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      ruleForm.value = res.data // 返回列表
      if (options.loadSuccess) {
        options.loadSuccess(res) // 加载成功后执行
      }
    } else {
      warningPrompt(res.message)
    }
  })
}
// 加载下拉框
export function loadSelect (options) {
  const data = options.data
  const o = { url: options.url, data: {} }
  if (options.parms) {
    o.data = options.parms
  }
  if (options.order) {
    o.data.order = options.order || 'createdTime'
    o.data.sort = options.sort || 'asc'
  }
  o.data.menuId = sessionStorage.getItem('menuId')
  actionPost(o).then((res) => {
    if (res.code === 200) {
      data.value = res.data || [] // 返回列表
      if (options.loadSuccess) {
        options.loadSuccess(res)
      }
    } else {
      warningPrompt(res.message)
    }
  })
}

/** ---------------------- 功能区 ---------------------- */

// 操作带提示提交
export function submitTiShi (options, callback) { // [url]接口地址 [ids] [callback]回调
  const confirmTitle = options.confirmTitle
  ElMessageBox.confirm(confirmTitle, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    ElMessageBox.close()
    options.parms.menuId = sessionStorage.getItem('menuId')
    action(options, callback)
  })
}

// 删除
export function submitDelete (url, ids, callback) { // [url]接口地址 [ids] [callback]回调
  if (ids.length === 0) {
    warningPrompt('至少选择一行')
    return
  }
  ElMessageBox.confirm('确定要删除吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    const loading = ElLoading.service({
      lock: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    const options = { url: url, data: ids } // [url]接口地址 [data]
    actionDelete(options).then((res) => {
      loading.close()
      if (res.code === 200) {
        if (callback) {
          callback(res) // 成功后回调
        }
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  })
}

// 提交表格
export function submitDataGridAction (options) { // [url]接口地址 [ids] [callback]回调
  const url = options.url
  const dataGrid = options.dataGrid
  const callback = options.callback
  const confirmTitle = options.confirmTitle
  const ids = dataGrid.multipleSelection
  const method = options.method ?? 'post'
  if (ids.length === 0) {
    warningPrompt('至少选择一行')
    return
  }
  if (confirmTitle) {
    ElMessageBox.confirm(confirmTitle, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      submitDataGridAction_action(url, ids, callback, method)
    })
  } else {
    submitDataGridAction_action(url, ids, callback, method)
  }
}
// eslint-disable-next-line camelcase
export function submitDataGridAction_action (url, ids, callback, method) {
  const data = { url: url, method: method, parms: { ids: ids, menuId: sessionStorage.getItem('menuId') } }
  action(data, callback)
}
export function action (options, callback) {
  const method = options.method ?? 'post'
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const o = { url: options.url, data: options.parms } // [url]接口地址 [data]
  if (method === 'post') {
    actionPost(o).then((res) => {
      loading.close()
      if (res.code === 200) {
        if (callback) {
          callback(res) // 成功后回调
        }
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  }
  if (method === 'patch') {
    actionPatch(o).then((res) => {
      loading.close()
      if (res.code === 200) {
        if (callback) {
          callback(res) // 成功后回调
        }
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  }
  if (method === 'delete') {
    actionDelete(o).then((res) => {
      loading.close()
      if (res.code === 200) {
        if (callback) {
          callback(res) // 成功后回调
        }
        successPrompt(res.message)
      } else {
        ElMessageBox.confirm(res.message, '警告',
          {
            showCancelButton: false,
            confirmButtonText: '关闭',
            type: 'warning'
          })
        // warningPrompt(res.message)
      }
    })
  }
}
// 添加
export function submitForm (options) {
  const form = options.ruleFormRef
  if (form) {
    form.validate((valid, fields) => {
      if (valid) {
        options.ruleForm.menuId = sessionStorage.getItem('menuId')
        const o = { url: options.url, data: options.ruleForm } // [url]接口地址 [data]获取表单数据
        const loading = ElLoading.service({
          lock: true,
          text: 'Loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        actionPost(o).then((res) => {
          loading.close()
          if (res.code === 200) {
            if (options.callback) {
              options.callback(res) // 成功后回调
            }
            successPrompt(res.message)
          } else {
            warningPrompt(res.message)
          }
        })
      } else {
        return console.log('error submit!', fields)
      }
    })
  }
}
// 编辑
export function submitEditForm (options) {
  const form = options.ruleFormRef
  if (form) {
    form.validate((valid, fields) => {
      if (valid) {
        options.ruleForm.menuId = sessionStorage.getItem('menuId')
        const o = { url: options.url, data: options.ruleForm } // [url]接口地址 [data]获取表单数据
        const loading = ElLoading.service({
          lock: true,
          text: 'Loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        actionPatch(o).then((res) => {
          loading.close()
          if (res.code === 200) {
            if (options.callback) {
              options.callback(res) // 成功后回调
            }
            successPrompt(res.message)
          } else {
            warningPrompt(res.message)
          }
        })
      } else {
        return console.log('error submit!', fields)
      }
    })
  }
}

// 关闭
// [window]窗体名称 [emits]触发开关 [isRefresh]关闭后是否刷新
export function closeWindow (window, emits, isRefresh) {
  emits('update:' + window, false)
  if (isRefresh) {
    emits('ReturnData')
  }
}
// 关闭
// [window]窗体名称 [emits]触发开关 [isRefresh]关闭后是否刷新
export function homeCloseWindow (window, emits, isRefresh) {
  emits(window, '')
  if (isRefresh) {
    emits('ReturnData')
  }
}

export function downloadTemplate (url, dataGrid) {
  // const loading = ElLoading.service({
  //   lock: true,
  //   text: 'Loading',
  //   background: 'rgba(0, 0, 0, 0.7)'
  // })
  requestDownload.exportExcel(url, dataGrid)
}
export function exportExcel (url, dataGrid) {
  if (dataGrid.orderBy) {
    dataGrid.parms.order = dataGrid.orderBy.prop || 'createdTime' // 排序条件
    dataGrid.parms.sort = dataGrid.orderBy.order === 'ascending' ? 'asc' : 'desc' // 排序方式
  }

  requestDownload.exportExcel(url, dataGrid.parms)
}

export function submitExcel (options) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const formData = new FormData()
  formData.append('parms', options.file.parms)
  formData.append('file', options.file.file)
  const o = { url: options.url, data: formData } // [url]接口地址 [data]获取表单数据
  actionPost(o).then((res) => {
    loading.close()
    if (res.code === 200) {
      if (options.callback) {
        options.callback(res) // 成功后回调
      }
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}

export function importClick (options) {
  const file = options.file // 文件
  const whiteList = options.whiteList || ['exe', 'com', 'bat', 'scr'] // 违规格式
  const url = options.url // 接口地址
  const wjjmc = options.wjjmc // 文件存储地址

  const fileSuffix = file.file.name.substring(
    file.file.name.lastIndexOf('.') + 1
  )
  // 检测违规格式 开始
  const isSuffix = whiteList.includes(fileSuffix.toLowerCase())
  if (isSuffix) {
    return warningPrompt('禁止上传 ' + whiteList + ' 格式文件')
  }
  // // 检测违规格式 结束
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', wjjmc) // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  axios({
    url: process.env.VUE_APP_BASE_API + url,
    data: formData,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      accesscode: $cookies.get(process.env.VUE_APP_BASE_TOKEN)
    },
    // 上传进度
    onUploadProgress: (progressEvent) => {
      if (progressEvent.lengthComputable) {
        options.loadProgress(true)
        // 是否存在进度
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        options.loadPercentage(percentCompleted)
        if (percentCompleted === 100) {
          options.loadProgress(true)
        }
      }
    }
  }).then((res) => {
    const obj = {
      oldname: res.data.data.ymc,
      showPath: res.data.data.lj + res.data.data.mc,
      id: res.data.data.id
    }
    options.fjList.push(obj)
  })
}

// 单个照片检测
export function checkPhoto (file) {
  // // 检查文件类型
  if (!file.type.match('image/jpeg') && !file.type.match('image/jpg')) {
    warningPrompt('请上传JPEG/JPG格式的图片')
    return false
  }
  // 检查图片文件大小（文件内存大小不能超过 2M）
  if (file.size > (1024 * 1024 * 2)) {
    warningPrompt('图片文件大小不能超过 2M')
    return false
  }
  // 使用FileReader读取图片信息

  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = (e) => {
    const img = new Image()
    img.onload = () => {
      // 检查尺寸 (像素大小上限为 1080*1920，下限为 300*300)
      if (img.width >= 1080 || img.height >= 1920 || img.width <= 300 || img.height <= 300) {
        warningPrompt('图片大小上限为 1080*1920，下限为 300*300')
        return false
      }
      // const canvas = document.createElement('canvas')
      // const ctx = canvas.getContext('2d')
      // canvas.width = img.width
      // canvas.height = img.height
      // // 检查背景色（这里简化处理，实际应用中可能需要更复杂的图像处理库）
      // ctx.drawImage(img, 0, 0)
      // const imageData = ctx.getImageData(0, 0, img.width, img.height)
      // let isWhiteBackground = true
      // for (let i = 0; i < imageData.data.length; i += 4) { // 每四个元素表示一个像素的RGBA值，我们只检查RGB部分，忽略Alpha（透明度）
      //   if (imageData.data[i] > 250 || imageData.data[i + 1] > 250 || imageData.data[i + 2] > 250) { // 检查是否非白色（简化处理，可根据需要调整容差）
      //     isWhiteBackground = false
      //     break
      //   }
      // }
      // if (!isWhiteBackground) {
      //   alert('图片背景色不符合要求')
      //   return
      // }
    }
    img.src = e.target.result // 设置图片源为读取的结果
  }
  // reader.readAsDataURL(file) // 读取文件内容为DataURL
  return true
}

// 批量照片检测
export function batchCheckPhoto (file, callback) {
  // 使用FileReader读取图片信息

  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = (e) => {
    const img = new Image()
    img.onload = () => {
      // 检查文件类型
      if (!file.type.match('image/jpeg') && !file.type.match('image/jpg')) {
        const fanhui = { isyz: false, img: e.target.result, name: file.name, yy: '请上传JPEG/JPG格式的图片' }
        callback(fanhui)
        return false
      }
      // 检查图片文件大小（文件内存大小不能超过 2M）
      if (file.size > (1024 * 1024 * 2)) {
        const fanhui = { isyz: false, img: e.target.result, name: file.name, yy: '图片文件大小不能超过 2M' }
        callback(fanhui)
        return false
      }
      // 检查尺寸 (像素大小上限为 1080*1920，下限为 300*300)
      if (img.width >= 1080 || img.height >= 1920 || img.width <= 300 || img.height <= 300) {
        const fanhui = { isyz: false, img: e.target.result, name: file.name, yy: '图片大小上限为 1080*1920，下限为 300*300' }
        callback(fanhui)
        return false
      }
      const fanhui = { isyz: true, img: e.target.result, name: file.name, yy: '符合要求', file: file }
      callback(fanhui)
    }
    img.src = e.target.result // 设置图片源为读取的结果
  }
  // reader.readAsDataURL(file) // 读取文件内容为DataURL
  return true
}
